import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ kicker, title, subtitle, center, className }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl ${className || ""}`}>
    {kicker && (
      <div className={`flex items-center gap-3 mb-4 ${center ? "justify-center" : ""}`}>
        <span className="h-px w-8 bg-amber-500" />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-amber-500">{kicker}</span>
      </div>
    )}
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-[1.03]">
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-base sm:text-lg text-white/60 leading-relaxed">{subtitle}</p>}
  </div>
);
